import { useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/registration-form.css";
import Toast from "../components/Toast";
// import CountdownOffer from "../components/CountdownOffer";
const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    programs: [],
    education: "Trung cấp",
    otherEducation: "",
    address: "",
    source: "Website: www.design24.edu.vn",
    otherSource: "",
    message: "",
    agreement: false,
  });
  const sendEmail = () => {
    const emailParams = {
      formName: "Chương trình đào tạo chứng chỉ quốc gia",
      fullName: formData.fullName,
      phone: formData.phone,
      email: formData.email,
      programs: formData.programs.join(", "),
      education:
        formData.education === "Khác"
          ? formData.otherEducation
          : formData.education,
      address: formData.address,
      source:
        formData.source === "Khác" ? formData.otherSource : formData.source,
      message: formData.message ? formData.message : "Không có lời nhắn",
    };

    emailjs
      .send(
        "service_3oo6e54",
        "template_los1h9c",
        emailParams,
        "Fg2TttehiRc-XVVCL"
      )
      .then((response) => {
        console.log("Email sent!", response.status, response.text);
        setToast({
          message: "Gửi đăng ký thành công! Chúng tôi sẽ liên hệ sớm.",
          type: "success",
        });

        // Reset form sau khi gửi thành công
        setFormData({
          fullName: "",
          phone: "",
          email: "",
          programs: [],
          education: "",
          otherEducation: "",
          address: "",
          source: "",
          otherSource: "",
          message: "",
          agreement: false,
        });

        setErrors({});
      })
      .catch((error) => {
        console.error("Email sending error:", error);
        setToast({
          message: "Gửi đăng ký thất bại, vui lòng thử lại!",
          type: "error",
        });
      });
  };

  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState(null);
  const validate = () => {
    const newErrors = {};

    if (!formData.fullName.trim())
      newErrors.fullName = "Họ và tên không thể để trống";

    if (!formData.phone.trim()) {
      newErrors.phone = "Số điện thoại không thể để trống";
    } else if (!/^\d{10,11}$/.test(formData.phone)) {
      newErrors.phone = "Số điện thoại không hợp lệ (10-11 số)";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email không thể để trống";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
    ) {
      newErrors.email = "Email không hợp lệ";
    }

    if (!formData.programs.length) {
      newErrors.programs = "Vui lòng chọn ít nhất một chương trình đào tạo";
    }

    if (!formData.agreement) {
      newErrors.agreement = "Bạn cần đồng ý với các điều khoản";
    }

    if (formData.education === "Khác" && !formData.otherEducation.trim()) {
      newErrors.otherEducation = "Vui lòng nhập trình độ học vấn khác";
    }

    if (formData.source === "Khác" && !formData.otherSource.trim()) {
      newErrors.otherSource = "Vui lòng nhập nguồn thông tin khác";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevState) => {
      if (type === "checkbox") {
        if (name === "agreement") {
          return { ...prevState, [name]: checked };
        } else {
          const updatedPrograms = checked
            ? [...prevState.programs, value]
            : prevState.programs.filter((program) => program !== value);
          return { ...prevState, programs: updatedPrograms };
        }
      }

      return { ...prevState, [name]: value };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      sendEmail();
    } else {
      setToast({
        message: "Vui lòng kiểm tra lại các trường thông tin.",
        type: "error",
      });
    }
  };

  return (
    <div className="registration-form-bg">
      <div className="registration-form">
        {toast && (
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => setToast(null)}
          />
        )}
        {/* <div className="registration-form__offer-wrapper">
          <CountdownOffer />
        </div> */}
        <div className="registration-form__title-container">
          <h1
            id="registration-form"
            className="registration-form__title"
          >
            ĐĂNG KÝ THAM GIA <br />
            <span className="highlighted">
              Chương trình đào tạo CHỨNG CHỈ QUỐC GIA
            </span>
          </h1>
          <p className="registration-form__subtitle">TẠI HỌC VIỆN DESIGN24</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="registration-form__form"
        >
          <div className="registration-form__field">
            <label
              htmlFor="fullName"
              className="registration-form__label"
            >
              Họ và tên <span className="required">*</span>
            </label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
              className="registration-form__input"
              placeholder="Nguyễn Văn A"
            />
            {errors.fullName && <div className="error">{errors.fullName}</div>}
          </div>

          <div className="registration-form__field">
            <label
              htmlFor="phone"
              className="registration-form__label"
            >
              Số điện thoại <span className="required">*</span>
            </label>
            <input
              type="text"
              name="phone"
              id="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              className="registration-form__input"
              placeholder="034 432 7071"
            />
            {errors.phone && <div className="error">{errors.phone}</div>}
          </div>

          <div className="registration-form__field">
            <label
              htmlFor="email"
              className="registration-form__label"
            >
              Email <span className="required">*</span>
            </label>
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="registration-form__input"
              placeholder="nguyenvana@gmail.com"
            />
            {errors.email && <div className="error">{errors.email}</div>}
          </div>

          <div className="registration-form__field">
            <label className="registration-form__label">
              Chương trình đào tạo quan tâm <span className="required">*</span>
            </label>
            <div className="registration-form__checkbox-group">
              {[
                // "KỸ THUẬT GHI HÌNH",
                // "PHÁT THANH VIÊN & MC",
                // "BIÊN TẬP BÁO CHÍ",
                // "ĐẠO DIỄN TRUYỀN HÌNH",
                // "NGHIỆP VỤ BÁO CHÍ",
                // "THIẾT KẾ ĐỒ HOẠ KIẾN TRÚC-NỘI THẤT",
                // "GAME & HOẠT HÌNH 3D",
                // "CHUYỂN ĐỔI SỐ DOANH NGHIỆP",
                // "THIẾT KẾ WEBSITE & APP MOBILE",
                // "A.I MULTIMEDIA DESIGN MASTERY",
                // "WEDDING MEDIA & STUDIO BUSINESS",
                // "DIGITAL MARKETING",
                // "FILM MEDIA DESIGNER PRO",
                // "GRAPHIC DESIGNER PRO",
                // "PHOTOGRAPHER PRO",
                // New

                "Thiết kế đồ họa quảng cáo",
                "Quay phim (kỹ thuật ghi hình)",
                "Dựng phim",
                "Nhiếp ảnh và xử lý ảnh",
                "MC - dẫn chương trình",
                "Đồ họa kiến trúc nội thất",
                "Trí tuệ nhân tạo ứng dựng",
                "Digital marketing",
                "Thiết kế game 3D cơ bản",
                "Thiết kế hoạt hình 2D",
                "Công nghệ livestream",
              ].map((program) => (
                <label key={program}>
                  <input
                    type="checkbox"
                    name="programs"
                    value={program}
                    checked={formData.programs.includes(program)}
                    onChange={handleChange}
                  />
                  {program}
                </label>
              ))}
            </div>
            {errors.programs && <div className="error">{errors.programs}</div>}
          </div>

          <div className="registration-form__field">
            <label
              htmlFor="education"
              className="registration-form__label"
            >
              Trình độ học vấn hiện tại
            </label>
            <select
              id="education"
              name="education"
              value={formData.education}
              onChange={handleChange}
              className="registration-form__select"
            >
              <option value="Trung cấp">Trung cấp</option>
              <option value="Cao đẳng">Cao đẳng</option>
              <option value="Đại học">Đại học</option>
              <option value="Khác">Khác</option>
            </select>
          </div>

          {/* Hiển thị trường nhập nếu chọn "Khác" */}
          <div
            className={`registration-form__field ${
              formData.education === "Khác"
                ? "registration-form__field--visible"
                : "registration-form__field--hidden"
            }`}
          >
            <label
              htmlFor="other-education"
              className="registration-form__label"
            >
              Trình độ học vấn (khác) <span className="required">*</span>
            </label>
            <input
              id="other-education"
              type="text"
              name="otherEducation"
              value={formData.otherEducation}
              onChange={handleChange}
              className="registration-form__input"
              placeholder="Nhập trình độ học vấn"
            />
            {errors.otherEducation && (
              <div className="error">{errors.otherEducation}</div>
            )}
          </div>

          <div className="registration-form__field">
            <label
              htmlFor="adress"
              className="registration-form__label"
            >
              Nơi ở hiện tại
            </label>
            <input
              id="adress"
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              className="registration-form__input"
              placeholder="Tầm Vu, Hưng Lợi, Ninh Kiều, TP Cần Thơ"
            />
          </div>

          <div className="registration-form__field">
            <label
              htmlFor="source"
              className="registration-form__label"
            >
              Nguồn thông tin biết đến chương trình
            </label>
            <select
              id="source"
              name="source"
              value={formData.source}
              onChange={handleChange}
              className="registration-form__select"
            >
              <option value="Website: www.design24.edu.vn">
                Website: www.design24.edu.vn
              </option>
              <option value="Fanpage: Học viện Design24">
                Fanpage: Học viện Design24
              </option>
              <option value="Bạn bè/Giới thiệu">Bạn bè/Giới thiệu</option>
              <option value="Quảng cáo">Quảng cáo</option>
              <option value="Khác">Khác</option>
            </select>
          </div>

          {/* Hiển thị trường nhập nếu chọn "Khác" */}
          <div
            className={`registration-form__field ${
              formData.source === "Khác"
                ? "registration-form__field--visible"
                : "registration-form__field--hidden"
            }`}
          >
            <label
              htmlFor="other-source"
              className="registration-form__label"
            >
              Nguồn thông tin (khác) <span className="required">*</span>
            </label>
            <input
              id="other-source"
              type="text"
              name="otherSource"
              value={formData.otherSource}
              onChange={handleChange}
              className="registration-form__input"
              placeholder="Nhập nguồn thông tin khác"
            />
            {errors.otherSource && (
              <div className="error">{errors.otherSource}</div>
            )}
          </div>

          <div className="registration-form__field">
            <label
              htmlFor="message"
              className="registration-form__label"
            >
              Lời nhắn hoặc câu hỏi (nếu có)
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="registration-form__textarea"
              placeholder="Nhập lời nhắn hoặc câu hỏi của bạn"
            />
          </div>

          <div className="registration-form__field">
            <label className="registration-form__checkbox-label">
              <input
                type="checkbox"
                name="agreement"
                checked={formData.agreement}
                onChange={handleChange}
              />
              Tôi đồng ý cung cấp thông tin để được tư vấn về các chương trình
              đào tạo tại Học viện Design24.
            </label>
            {errors.agreement && (
              <div className="error">{errors.agreement}</div>
            )}
          </div>

          <div className="registration-form__field">
            <button
              type="submit"
              className="registration-form__submit-button"
            >
              GỬI ĐĂNG KÝ
            </button>
          </div>
        </form>

        <div className="registration-form__footer">
          <p>
            Hotline tư vấn & hỗ trợ: <a href="tel:0704888009">0704 888 009</a> -
            <a href="tel:0784888009"> 0784 888 009</a>
          </p>
          <p>
            Địa chỉ: 166 Nguyễn Văn Cừ, P. An Bình, Q. Ninh Kiều, TP. Cần Thơ,
            Việt Nam
          </p>
          <p>
            Website:{" "}
            <a
              href="https://www.design24.edu.vn"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.design24.edu.vn
            </a>{" "}
            | Fanpage: Học viện Design24
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;
